// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"7fa1301d","436":"7e61f4d8","632":"91b999a3","767":"2f278264","895":"b9c54a51"}[chunkId] + ".chunk.js";
};